import { z } from "zod";

const connectDeviceToProviderRequestItemSchema = z.object({
  vehicleUuid: z.uuid(),
  vin: z.string(),
  registrationNumber: z.string(),
  companyUuid: z.uuid(),
  departmentUuid: z.uuid().nullable(),
  deviceId: z.string(),
  brand: z.string(),
  updatedBy: z.string(),
});

export const connectDevicesToProviderRequestPayloadSchema = z.object({
  data: z.array(
    connectDeviceToProviderRequestItemSchema.omit({ updatedBy: true }),
  ),
});

export type ConnectDevicesToProviderRequestPayload = z.infer<
  typeof connectDevicesToProviderRequestPayloadSchema
>;
